import fetch from '../fetch'
import Qs from 'qs'
// 重构接口开始

/**
 * 获取续费域名
 * @param {*} params
 */
export function getDNShoppingCartSelectListByDomainID (params) {
  return fetch({
    url: '/DNShoppingCart/GetDNShoppingCartSelectListByDomainID',
    method: 'get',
    params
  })
}
/**
 * 证书图片
 * @param {*} params
 */
export function GetPic (params) {
  return fetch({
    url: '/DNService/GetPic',
    method: 'get',
    params
  })
}
/**
 * 持有者认证查看
 * @param {*} params
 */
export function GetAuthenticationInfo (params) {
  return fetch({
    url: '/DNService/GetAuthenticationInfo',
    method: 'get',
    params
  })
}
/**
 * 购买西安工大
 * @param {*} params
 */
export function SpecialDomains (params) {
  return fetch({
    url: '/SpecialDomain/SpecialDomains',
    method: 'get',
    params
  })
}
/**
 * 字典表
 * @param {*} params
 */
export function GetDictAllList (params) {
  console.log(32222)
  return fetch({
    url: '/Dict/GetDictAllList',
    method: 'get',
    params
  })
}
/**
 * 判断登录用户有无购买过西安工大域名
 * @param {*} params
 */
export function IsBuyxagd (params) {
  return fetch({
    url: '/SpecialDomain/IsBuyxagd',
    method: 'get',
    params
  })
}
/**
 * 删除域名服务信息
 * @param {*} params
 */
export function DeleteDNService (params) {
  return fetch({
    url: '/DNService/DeleteDNService',
    method: 'post',
    params
  })
}

/**
 * 发送验证码
 * @param {*} params
 */
export function sendCode (params) {
  return fetch({
    url: '/SMUsers/SendSMSCode',
    method: 'get',
    params
  })
}

/**
 * 登录注册
 * @param {*} params
 */
export function userLogin (params) {
  return fetch({
    url: '/SMUsers/UserLogin',
    method: 'post',
    data: params
  })
}

/**
 * 设置密码、修改密码、找回密码
 * @param {*} params
 */
export function changePassword (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUsers/ModifyPassword',
    method: 'post',
    params
  })
}
/**
 * 退出登录
 * @param {*} params
 */
export function logout (params) {
  return fetch({
    url: '/SMUsers/UserLogout',
    method: 'post',
    params
  })
}

/**
 * 获取账号信息
 * @param {*} params
 */
export function userProfile (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUsers/GetUserInfo',
    method: 'get',
    params
  })
}

/**
 * 验证手机验证码
 * @param {*} params
 */
export function checkCode (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: `/SMUsers/CheckSMSCode`,
    method: 'post',
    params
  })
}

/**
 * 更改手机号码
 * @param {*} params
 */
export function changePhone (params) {
  return fetch({
    url: '/SMUsers/ModifyPhoneNo',
    method: 'post',
    params
  })
}

// /**
//  * 账单信息列表
//  * @param {*} params
//  */
export function payRecordList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    // url: '/Orders/GetOrderList',
    url: '/SMUsers/SMUserEbankList',
    method: 'get',
    params
  })
}

/**
 * 更改头像图片
 * @param {*} params
 */
export function uploadHead (params) {
  return fetch({
    url: '/SMUsers/ModifyHeadIcon',
    method: 'post',
    params
  })
}

/**
 * 添加用户本人认证
 * @param {*} data
 */
export function varifySelf (data) {
  return fetch({
    url: '/SMUserTemplate/AddUserTemplate',
    method: 'POST',
    data
  })
}

/**
 * 首页查询域名
 * @param {*} params
 */
export function domainsearch (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNEval/DomainQuery',
    method: 'get',
    params
  })
}
/**
 * 首页查询域名最大金额
 * @param {*} params
 */
export function getdomainMaxPrice (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/manage/config/price',
    method: 'get',
    params
  }, {noLoad: true})
}
/**
 * .CHN查询
 * @param {*} params
 */
export function searchDomain (params, cancelTokenSource) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNEval/DomainQuery',
    method: 'get',
    params
  }, cancelTokenSource)
}

/**
 * 购物车列表
 * @param {*} params
 */
export function domainSelectList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNShoppingCart/GetDNShoppingCartSelectList',
    method: 'get',
    params
  })
}

// 获取认证模板信息
export function GetTemplateInfo (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUserTemplate/GetTemplateInfo',
    method: 'get',
    params
  })
}
// 删除模板信息
export function DeleteTemplateInfo (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUserTemplate/DeleteTemplateInfo',
    method: 'get',
    params
  })
}

// 清单列表
export function domainList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNShoppingCart/GetDNShoppingCartList',
    method: 'get',
    params
  })
}
// 判断某个域名是否可以注册
export function GetDNCanRegister (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNService/GetDNCanRegister',
    method: 'get',
    params
  }, {noLoad: true}
  )
}
// 销售代码
export function CheckSaleCode (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMAgents/CheckSaleCode',
    method: 'get',
    params
  })
}
// 有效.chn 基本信息
export function GetDNServiceInfo (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNService/GetDNServiceInfo',
    method: 'get',
    params
  })
}
// 获取域名Whois详情
export function GetDNWhois (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNService/GetDNWhois',
    method: 'get',
    params
  })
}
// 获取域名服务解析详情
export function GetDNServiceResolInfo (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNServiceResol/GetDNServiceResolInfo',
    method: 'get',
    params
  })
}

/**
 * 修改发票抬头
 * @param {*} params
 */
export function updateInvoice (params) {
  return fetch({
    url: '/SMUserTicketHeader/ModifySMUserTicketHeader',
    method: 'post',
    data: params
  })
}

// 获取发票抬头
export function getHeadByUserId (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUserTicketHeader/GetSMUserTicketHeaderInfo',
    method: 'get',
    params
  })
}
// 修改域名服务
export function ModifyDNService (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNService/ModifyDNService',
    method: 'post',
    data: params
  })
}
// 修改域名服务
export function GetDNServiceResolList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNServiceResol/GetDNServiceResolList',
    method: 'get',
    params
  })
}
// 修改域名服务
export function AddDNServiceResol (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNServiceResol/AddDNServiceResol',
    method: 'post',
    data: params
  })
}

// 重构接口结束

// 实名认证

// 添加实名认证信息
export function addvetify (data) {
  return fetch({
    url: '/varify/add',
    method: 'POST',
    data
  })
}
// 更新实名认证信息
export function updateUserVarify (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/varify/updateUserVarify',
    method: 'get',
    params
  })
}

// //添加用户本人认证
// export function varifySelf(data) {
//   return fetch({
//     url: "/varify/self",
//     method: "POST",
//     data
//   });
// }

// 添加模板实名认证
export function addmodelvetify (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/model/verifyModel',
    method: 'get',
    params
  })
}

// 查询实名认证信息
export function getvetifydetail (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/varify/getOneVerify',
    method: 'get',
    params
  })
}
// 查询本人认证信息
export function getSelfVetifydetail (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/varify/detail/' + params,
    method: 'get'
  })
}
// 邮箱验证

// 获取邮箱列表
export function emaillist (params) {
  return fetch({
    url: '/email/emailList',
    method: 'POST',
    params
  })
}

// 添加邮箱信息
export function addemail (params) {
  return fetch({
    url: '/email/checkEmail',
    method: 'POST',
    params
  })
}
// //邮箱和模板绑定
// export function emailModel(params) {
//   return fetch({
//     url: '/model/emailModel',
//     method: 'get',
//     params
//   })
// }
// 查询验证邮箱
export function selsetemail (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/email/checkToken',
    method: 'get',
    params
  })
}
// 删除邮箱信息
export function deleteemail (params) {
  return fetch({
    url: '/email/delete',
    method: 'POST',
    params
  })
}

// 信息模板

// 获取信息模板列表
export function messagelist (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUserTemplate/GetTemplateList',
    method: 'get',
    params
  })
}

// 添加信息模板
export function AddUserTemplate (params) {
  return fetch({
    url: '/SMUserTemplate/AddUserTemplate',
    method: 'POST',
    data: params
  })
}

// 更新信息模板
export function ModifyTemplateInfo (params) {
  return fetch({
    url: '/SMUserTemplate/ModifyTemplateInfo',
    method: 'POST',
    data: params
  })
}

// 获取个人或企业模板
export function GetTemplateList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/SMUserTemplate/GetTemplateList',
    method: 'get',
    params
  })
}

// 认证信息

// /search 首页检索
// 参数 domain  .CHN 该参数应该是不包含后缀 如 adbc
// 参数 user_id
// 返回 true可以购买
// 	 false 不能购买

// /add 新增
// 参数 domainbody  .CHN，该字段应该是包含后缀，如 adbc.chn
// 	 user_id 用户id
// 	 item_time_length 购买时间长度 初始应传入1
// 返回 创建成功将返回 item_id
// 	 如果该 .CHN正在使用或者 .CHN存在问题将会导致新增失败

// 新增 .CHN
export function domainadd (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNShoppingCart/AddDNShoppingCart?' + `DNState=${params.DNState}&DomainName=${params.DomainName}&SalePrice=${params.SalePrice}&UserId=${params.UserId}&UserName=${params.UserName}&Years=${params.Years}&time=${params.time}`,
    method: 'post',
    data: params
  })
}
// 新增订单
export function addOrder (data) {
  return fetch({
    url: '/Orders/AddOrder',
    method: 'post',
    data
  })
}
// 建行
export function OrderPay (params) {
  return fetch({
    url: '/Orders/OrderPay',
    method: 'get',
    params
  })
}
export function getOrderPay (params) {
  return fetch({
    url: '/Orders/PayInterface',
    method: 'get',
    params
  })
}

// /list 订单列表
// 参数 user_id 用户id
// 	 commitFrom 提交时间 检索的开始时间
// 	 commitEnd  提交时间 检索的结束时间
// 	 payFrom    支付时间 检索的开始时间
// 	 payEnd     支付时间 检索的结束时间
// 	 pageIndex  当前页码
// 	 pageSize   每页条数
// 返回 订单的列表和总条数
// 审核中
export function Orderlist (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/Orders/GetOrderList',
    method: 'get',
    params
  })
}
// /detail 订单详情
// 参数 order_id 订单id
export function OrderInfo (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/Orders/GetOrderInfo',
    method: 'get',
    params
  }, {noLoad: true})
}
// 审核记录
export function auditRecordList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/ordersAuditRecord/itemList',
    method: 'get',
    params
  })
}
// 审核记录详情
export function auditRecordDetail (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/orders/detail',
    method: 'get',
    params
  })
}
// .CHN列表

// 全部 .CHN列表
export function DNServiceList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/DNService/GetDNServicePageList',
    method: 'get',
    params
  })
}

// 急需续费 .CHN列表
export function renewDomain (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/domain/renewDomain',
    method: 'get',
    params
  })
}

// .CHN解析
// .CHN解析列表
export function dnsList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: 'dns/domainStatusList',
    method: 'get',
    params
  })
}
// .CHN解析设置
export function setdnsList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/dns/domainDnsRecords',
    method: 'get',
    params
  })
}

//

// 增加或修改 .CHN解析
export function addOrUpdate (data) {
  return fetch({
    url: 'dns/addOrUpdate',
    method: 'POST',
    data
  })
}

// .CHN解析详情
export function dnsdetail (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: 'dns/detail',
    method: 'get',
    params
  })
}

// //修改 .CHN解析
// export function updatesetdns(data) {
//   return fetch({
//     url: '/dns/update',
//     method: 'POST',
//     data
//   })
// }
// 删除 .CHN解析
export function deletesetdns (data) {
  return fetch({
    url: `dns/delete?dns_id=${data.dns_id}`,
    method: 'POST',
    data
  })
}

// 发票管理

// 获取省市区
export function regionTree (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/region/tree',
    method: 'get',
    params
  })
}

// whois信息
export function whois (params) {
  return fetch({
    url: '/DNService/GetDNWhois',
    method: 'get',
    params
  })
}

// 添加收货地址信息
export function addressInsertOrUpdate (data) {
  return fetch({
    url: '/address/insertOrUpdate',
    method: 'POST',
    data
  })
}

// 删除收货地址信息
export function deleteAddressInsertApi (params) {
  return fetch({
    url: '/address/delete',
    method: 'POST',
    params
  })
}

// 获取收货地址列表
export function addressList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/address/list',
    method: 'get'
  })
}
// //清单列表
// export function domainList(params) {
//   let time = new Date().getTime();
//   params = !params ? {} : params;
//   params["time"] = time;
//   return fetch({
//     url: "/item/orderList",
//     method: "get",
//     params
//   });
// }
// 移除清单
export function removeList (params) {
  return fetch({
    url: '/DNShoppingCart/DeleteDNShoppingCart',
    method: 'post',
    params
  })
}
// 清空清单
export function emptyDomainList (params) {
  return fetch({
    url: '/DNShoppingCart/DeleteAll',
    method: 'post',
    params
  })
}
// 索要发票列表
export function issueInvoiceList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/Orders/GetOrderUnTicketList',
    method: 'get',
    params
  })
}
// 发票列表
export function getInvoiceList (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/Orders/GetOrderTicketList',
    method: 'get',
    params
  })
}
// //索要发票
export function insertInvoice (data) {
  return fetch({
    url: '/SMUserTicketHeader/AddSMUserTicketHeader',
    method: 'post',
    data
  })
}
// 发票提交
// export function AddSMUserTicketHeader(data) {
//     let time = new Date().getTime();
//     params = !params ? {} : params;
//     params["time"] = time;
//     return fetch({
//       url: "/SMUserTicketHeader/AddSMUserTicketHeader",
//       method: "post",
//       data
//     });
//   }
// //获取发票抬头
// export function getHeadByUserId(params) {
//   let time = new Date().getTime();
//   // params = !params ? {} : params;
//   // params['time'] = time;
//   return fetch({
//     url: "/head/getHeadByUserId/" + params + "?time=" + time,
//     method: "get"
//   });
// }
// 获取发票详情
export function invoiceDetail (params) {
  return fetch({
    url: '/invoice/detail',
    method: 'POST',
    params
  })
}
// //修改发票抬头
// export function updateInvoice(params) {
//   return fetch({
//     url: "/head/insertOrUpdate",
//     method: "post",
//     params
//   });
// }

// 再次购买
export function itembuyAgain (params) {
  return fetch({
    url: '/item/buyAgain',
    method: 'POST',
    params
  })
}

// 删除 .CHN
export function itemremoveItem (params) {
  return fetch({
    url: '/item/removeItem',
    method: 'POST',
    params
  })
}

// // .CHN基本信息
// export function domainDetail(params) {
//   return fetch({
//     url: "/item/domainDetail",
//     method: "POST",
//     params
//   });
// }
// 持有者过户、信息修改
export function modelUpdate (data) {
  return fetch({
    url: '/model/updateModelAndVerify',
    method: 'POST',
    data
  })
}
// 判断支付金额是否大于10w
export function findChinaAmount (params) {
  return fetch({
    url: '/orders/findChinaAmount/' + params,
    method: 'post'
  })
}
// DNService/ModifyDNService
// 获取图片
export function getAllPhoto (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/upload/getAllPhoto',
    method: 'get',
    params
  })
}

// 获取下载安卓的apk

export function uploadGetQrCode (params) {
  let time = new Date().getTime()
  params = !params ? {} : params
  params['time'] = time
  return fetch({
    url: '/upload/getQrCode',
    method: 'get',
    params
  })
}

// 获取阅读数
export function getReadAmount () {
  return fetch({
    url: '/upload/getReadAmount',
    method: 'post'
  })
}

// 添加退款信息
export function addRefund (params) {
  return fetch({
    url: '/refund/add',
    method: 'post',
    data: params
  })
}
// 省市下拉
// export function regionlist(params) {
//   return fetch({
//     url: "/region/tree",
//     method: "get"
//     // data: params
//   });
// }

// 获取退款信息
export function getRefund (params) {
  return fetch({
    url: '/refund/info/' + params.id,
    method: 'get'
  })
}

// 获取购买页面订单信息
export function getOrderInfo (params) {
  return fetch({
    url: '/item/info/' + params.ids,
    method: 'get'
  })
}

// 获取 .CHN注册证书
export function generateNewCert (params) {
  return fetch({
    url: '/item/generateNewCert/' + params,
    method: 'post'
  })
}

// 获取地址下拉
export function regionlist (params) {
  return fetch({
    url: '/Address/AddressList',
    method: 'get',
    params
  })
}
// var newaddress = "http://192.168.18.69:5001";
var newaddress = 'https://www.dtgty.com'
// 获取下单
export function place (params) {
  return fetch({
    url: newaddress + '/bdthwebapi/DM_XAGDDomain/OrderInfo',
    method: 'get',
    params
  })
}
// // 获取地址下拉
// export function regionlist(params) {
//   return fetch({
//     url: newaddress + "/bdthwebapi/DM_XAGDDomain/GetAddress",
//     method: "get",
//     params
//   });
// }
// 提交订单
export function buy (params) {
  return fetch({
    url: newaddress + '/bdthwebapi/DM_XAGDDomain/Buy',
    method: 'get',
    params
  })
}
// 查看详情西安工大
export function GetOrderAuditsList (params) {
  return fetch({
    url: '/OrderAudits/GetOrderAuditsList',
    method: 'get',
    params
  })
}
// // 订单详情西安工大
// export function getdetaillist(params) {
//   return fetch({
//     url: newaddress + "/bdthwebapi/DM_XAGDDomain/GetOrderInfo",
//     method: "get",
//     params
//   });
// }
// 重新提交
export function submits (params) {
  return fetch({
    url: newaddress + '/bdthwebapi/DM_XAGDDomain/UpdateVerify',
    method: 'get',
    params
  })
}

// export function getdetaillist(params) {
//   return fetch({
//     url: newaddress + "/bdthwebapi/DM_XAGDDomain/UpdateVerify",
//     method: "get",
//     params
//   });
// }
// 批量删除订单发票 /SMUserTicketHeader/deleteInvoiceList
export function allDel (params) {
  return fetch({
    url: `/SMUserTicketHeader/deleteInvoiceList`,
    method: 'post',
    params
  })
}

// 查询客服是否在线
export function getKfOnline (params) {
  return fetch({
    url: `http://testkf.fn117.com/kf/login/queryAdmin`,
    method: 'get',
    params: {enabled: 'dtgt'}
  })
}

// 下载https证书
export function downloadHttpsApi (params) {
  return fetch({
    url: `/DNService/certificate`,
    method: 'get',
    params,
    responseType: 'blob' // 关键项，指明响应类型为Blob对象
  })
}

// 获取域名特定基数信息
export function DomainQuery2 (params, cancelTokenSource) {
  return fetch({
    url: '/DNEval/DomainQuery2',
    method: 'get',
    params
  }, cancelTokenSource)
}

// 获取域名特定基数信息
export function getAddressApi () {
  return fetch({
    url: '/region/tree',
    method: 'get'
  })
}

// 获取域名特定基数信息
export function getConfigDnsApi () {
  return fetch({
    url: '/common/config/dns',
    method: 'get'
  })
}

// 获取chn工具下载链接
export function getAppUrListApi () {
  return fetch({
    url: `/common/app`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js